// ============================================================
// PRETRAGA — bez obzira na pismo, velika/mala slova i kvačice:
// "ТЕАТАР ВУК", "Teatar Vuk" i "teatar vuk" se poklapaju; č/ć→c, š→s, ž→z, đ→dj, љ→lj, њ→nj, џ→dz
// ============================================================

const CYR = {
  а: 'a', б: 'b', в: 'v', г: 'g', д: 'd', ђ: 'dj', е: 'e', ж: 'z', з: 'z', и: 'i', ј: 'j', к: 'k',
  л: 'l', љ: 'lj', м: 'm', н: 'n', њ: 'nj', о: 'o', п: 'p', р: 'r', с: 's', т: 't', ћ: 'c', у: 'u',
  ф: 'f', х: 'h', ц: 'c', ч: 'c', џ: 'dz', ш: 's',
};

export const searchKey = (s) => String(s ?? '')
  .toLowerCase()
  .replace(/[а-яђјљњћџ]/g, (ch) => CYR[ch] ?? ch)
  .replace(/đ/g, 'dj')
  .replace(/dž/g, 'dz')
  .normalize('NFD')
  .replace(/[̀-ͯ]/g, '');
